@import '../../../../constants/spacing.module.less';

.upload-subsection {
  padding: @space-0 @space-16 @space-16 @space-16;
}

.section-header {
  align-items: center;
  flex-wrap: nowrap;
}

.refresh-icon {
  width: 14px;
  height: 14px;
}

.starter-content {
  align-items: flex-start;
}

.starter-description {
  margin: 0;
  color: var(--grey-600);
}
